/** Accessible drop zone for file uploads. Wraps React Aria DropZone. */
import {
  DropZone as AriaDropZone,
  type DropZoneProps as AriaDropZoneProps,
} from 'react-aria-components';
import { cn } from '@/foundation/utils/cn';

export function DropZone({ className, ...props }: AriaDropZoneProps) {
  return (
    <AriaDropZone
      className={(renderProps) => {
        const base = cn(
          'flex flex-col items-center justify-center rounded-xl border-2 border-dashed transition-colors',
          'border-[var(--f-border)] bg-[var(--f-bg-sunken)]',
          renderProps.isDropTarget && 'border-[var(--f-accent)] bg-[var(--f-accent)]/5'
        );
        const custom = typeof className === 'function' ? className(renderProps) : className;
        return cn(base, custom);
      }}
      {...props}
    />
  );
}
